/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, parseDate, parseDateTime, serializeDate, serializeDateTime } from '../runtime';
/**
 * 
 * @export
 * @interface InboundDocumentSplitRequest
 */
export interface InboundDocumentSplitRequest {
    /**
     * 
     */
    expected_date_modified: Date;
    /**
     * Inclusive one-indexed page ranges, one per child, covering every page exactly once
     */
    ranges: Array<Array<number>>;
}

/**
 * Check if a given object implements the InboundDocumentSplitRequest interface.
 */
export function instanceOfInboundDocumentSplitRequest(value: object): value is InboundDocumentSplitRequest {
    if (!('expected_date_modified' in value) || value['expected_date_modified'] === undefined) return false;
    if (!('ranges' in value) || value['ranges'] === undefined) return false;
    return true;
}

export function InboundDocumentSplitRequestFromJSON(json: any): InboundDocumentSplitRequest {
    return InboundDocumentSplitRequestFromJSONTyped(json, false);
}

export function InboundDocumentSplitRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): InboundDocumentSplitRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'expected_date_modified': (json['expected_date_modified'] == null ? json['expected_date_modified'] : parseDateTime(json['expected_date_modified'])),
        'ranges': json['ranges'],
    };
}

export function InboundDocumentSplitRequestToJSON(json: any): InboundDocumentSplitRequest {
    return InboundDocumentSplitRequestToJSONTyped(json, false);
}

export function InboundDocumentSplitRequestToJSONTyped(value?: InboundDocumentSplitRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'expected_date_modified': value['expected_date_modified'] == null ? value['expected_date_modified'] : serializeDateTime(value['expected_date_modified']),
        'ranges': value['ranges'],
    };
}

